import { NavLink, useLocation } from "react-router-dom";
import { NAV_GROUPS } from "@/lib/nav";
import { cn } from "@/lib/utils";
import { Activity } from "lucide-react";

export default function Sidebar({ onNavigate }) {
  const loc = useLocation();
  return (
    <aside className="flex h-full w-64 shrink-0 flex-col border-r bg-[hsl(var(--sidebar))] text-slate-300">
      <div className="flex h-16 items-center gap-2.5 px-5">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#155EEF] text-white shadow-lg shadow-[#155EEF]/30">
          <Activity size={20} strokeWidth={2.4} />
        </span>
        <div className="leading-tight">
          <div className="text-[15px] font-bold tracking-tight text-white">CAREIQ</div>
          <div className="text-[10px] font-medium uppercase tracking-widest text-slate-500">Human Services OS</div>
        </div>
      </div>

      <nav className="careiq-scroll flex-1 overflow-y-auto px-3 pb-6">
        {NAV_GROUPS.map((group) => (
          <div key={group.label} className="mb-4">
            <div className="px-3 pb-1.5 pt-2 text-[10px] font-semibold uppercase tracking-widest text-slate-500">
              {group.label}
            </div>
            {group.items.map((item) => {
              const active = item.to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(item.to);
              const Icon = item.icon;
              return (
                <NavLink key={item.to} to={item.to} onClick={onNavigate}
                  data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "")}`}
                  className={cn(
                    "group relative mb-0.5 flex items-center gap-3 rounded-md px-3 py-2 text-[13px] font-medium transition-colors duration-200",
                    active ? "bg-white/10 text-white" : "text-slate-400 hover:bg-white/5 hover:text-slate-100"
                  )}>
                  {active && <span className="absolute left-0 top-1/2 h-5 -translate-y-1/2 rounded-r bg-[#155EEF]" style={{ width: 3 }} />}
                  <Icon size={17} strokeWidth={2} className={item.ai ? "text-[#7C3AED]" : ""} />
                  <span className="flex-1">{item.label}</span>
                  {!item.live && <span className="rounded bg-white/5 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-slate-500">Soon</span>}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
}
